// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2NfO1","question":"Question_question__3-IK4","description":"Question_description__cY8JM"};